module.exports = __webpack_public_path__ + "img/email.2ba49287.svg";